module.exports = __webpack_public_path__ + "img/mobile-data2-grey24.7fb48702.svg";